// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "inbound_management_ui_styles" + "." + "211fc693" + ".chunk.css";
};